import { Instance } from 'mobx-state-tree';
import { SupportOrganizationDtoModelBase } from './SupportOrganizationDtoModel.base';

/* The TypeScript type of an instance of SupportOrganizationDtoModel */
export interface SupportOrganizationDtoModelType extends Instance<typeof SupportOrganizationDtoModel.Type> {}

/* A graphql query fragment builders for SupportOrganizationDtoModel */
export { selectFromSupportOrganizationDto, supportOrganizationDtoModelPrimitives, SupportOrganizationDtoModelSelector } from './SupportOrganizationDtoModel.base';

/**
 * SupportOrganizationDtoModel
 */
export const SupportOrganizationDtoModel = SupportOrganizationDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
